import sendMetrics from "modules/metrics/sendMetrics.js";

export default function sendStudentCabinetMetrics(obj) {
    const counters = {
        counterYM: window.$yaStudentCabinetCounter,
        counterGA: window.$gaStudentCabinetCounter 
    }
    sendMetrics({ ...counters, ...obj })
}